module.exports = __webpack_public_path__ + "static/media/engineering-support_bg_icon.604d5ed3.svg";